import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProgressService {
  private readonly _activeRequests = signal(0);

  readonly isLoading = computed(() => this._activeRequests() > 0);

  increment(): void {
    this._activeRequests.update((v) => v + 1);
  }

  decrement(): void {
    this._activeRequests.update((v) => Math.max(0, v - 1));
  }
}
